import { useMemo } from 'react';
import useLocalization from '~/App/shared/hooks/useLocalization';
import { isExportDomain } from '~/App/shared/localization/helpers';
import { isSwedishDomainOnlyPath } from '~/routes';

const useIsRouteAvailableOnDomain = (nonTranslatedPath: string) => {
  const { domainLocale } = useLocalization();
  const isSwedishDomainOnly = useMemo(
    () => isSwedishDomainOnlyPath(nonTranslatedPath),
    [nonTranslatedPath]
  );

  return !isExportDomain(domainLocale) || !isSwedishDomainOnly;
};

export default useIsRouteAvailableOnDomain;
